var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-page"},[_c('h1',[_vm._v(_vm._s(_vm.$t('publice.copyright')))]),_c('SanitizedHtml',{attrs:{"htmlContent":_vm.content}}),_c('p',[_vm._v("本网站上所有内容均受版权保护，未经许可不得转载或复制。")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }